import * as React from 'react';
import { observer } from 'mobx-react-lite';

export const ModalMessageSpinner: React.FC<any> = observer(
	() =>
	{
		return (
			<div className="modal-content">
				<div className="loading d-flex align-items-center justify-content-center">
					<svg className="loader" width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M74.5059 38.5498C74.5059 58.77 58.1704 75.1055 37.9502 75.1055C17.73 75.1055 1.39453 58.77 1.39453 38.5498C1.39453 18.3297 17.8297 1.99414 38.0498 1.99414C58.1704 1.99414 74.5059 18.3297 74.5059 38.5498ZM6.57408 38.5498C6.57408 55.8814 20.6186 69.926 37.9502 69.926C55.2818 69.926 69.3264 55.8814 69.3264 38.5498C69.3264 21.2183 55.3814 7.07409 38.0498 7.07409C20.7183 7.07409 6.57408 21.2183 6.57408 38.5498Z" fill="#CCDDFF" />
						<path d="M72.0157 38.5498C73.4102 38.5498 74.6055 37.3545 74.5059 35.96C74.2071 32.0753 73.3106 28.1907 71.8165 24.5052C70.0236 20.1225 67.3342 16.0387 63.9476 12.652C60.5609 9.26539 56.5767 6.57601 52.0944 4.78309C48.4089 3.28898 44.6239 2.39252 40.6396 2.0937C39.2451 1.99409 38.0498 3.18938 38.0498 4.58387C38.0498 5.97837 39.2451 7.17365 40.6396 7.27326C43.827 7.47247 47.0144 8.26932 50.0026 9.4646C53.7877 11.0583 57.2739 13.3493 60.1625 16.2379C63.0511 19.1265 65.4417 22.6127 66.9358 26.3978C68.2307 29.386 68.9279 32.5734 69.2267 35.8604C69.4259 37.3545 70.5216 38.5498 72.0157 38.5498Z" fill="#0057FF" />
					</svg>
				</div>
			</div>
		);
	}
)
